import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { MatSnackBar } from '@angular/material';

const DB_PATH = '/meta/worqFlexiDomains';

interface Domain {
  _index: number;
  domain: string;
  _editing?: boolean;
  _saving?: boolean;
  _draft?: string;
}

@Component({
  selector: 'app-config-worqflexi-domains',
  templateUrl: './config-worqflexi-domains.component.html',
  styleUrls: ['./config-worqflexi-domains.component.scss']
})
export class ConfigWorqflexiDomainsComponent implements OnInit {
  all: Domain[] = [];
  filtered: Domain[] = [];
  loading = true;
  quickSearch = '';

  showAddPanel = false;
  adding = false;
  newDomain = '';

  constructor(private db: AngularFireDatabase, private snack: MatSnackBar) {}

  ngOnInit() {
    this.db.database.ref(DB_PATH).once('value', snapshot => {
      const val = snapshot.val();
      if (Array.isArray(val)) {
        this.all = val
          .map((v, i) => ({ _index: i, domain: v || '' }))
          .filter(d => !!d.domain)
          .sort((a, b) => a.domain.localeCompare(b.domain));
      }
      this.loading = false;
      this.applyFilter();
    });
  }

  applyFilter() {
    const q = this.quickSearch.trim().toLowerCase();
    this.filtered = this.all.filter(d => !q || d.domain.toLowerCase().includes(q));
  }

  startEdit(d: Domain) {
    d._draft = d.domain;
    d._editing = true;
  }

  cancelEdit(d: Domain) { d._editing = false; d._draft = undefined; }

  async saveEdit(d: Domain) {
    const val = (d._draft || '').trim().toLowerCase();
    if (!val) { this.snack.open('Domain cannot be empty.', 'OK', { duration: 2500 }); return; }
    d._saving = true;
    try {
      await this.db.database.ref(`${DB_PATH}/${d._index}`).set(val);
      d.domain = val;
      d._editing = false; d._draft = undefined;
      this.all.sort((a, b) => a.domain.localeCompare(b.domain));
      this.applyFilter();
      this.snack.open(`${val} saved`, 'OK', { duration: 2500 });
    } catch (e) {
      this.snack.open('Save failed. Please try again.', 'OK', { duration: 3000 });
    }
    d._saving = false;
  }

  openAddPanel() { this.newDomain = ''; this.showAddPanel = true; }
  cancelAdd() { this.showAddPanel = false; }

  async addDomain() {
    const val = this.newDomain.trim().toLowerCase();
    if (!val) { this.snack.open('Domain cannot be empty.', 'OK', { duration: 2500 }); return; }
    if (this.all.find(d => d.domain === val)) {
      this.snack.open(`${val} already exists.`, 'OK', { duration: 2500 }); return;
    }
    this.adding = true;
    const nextIndex = this.all.length > 0 ? Math.max(...this.all.map(d => d._index)) + 1 : 0;
    try {
      await this.db.database.ref(`${DB_PATH}/${nextIndex}`).set(val);
      const entry: Domain = { _index: nextIndex, domain: val };
      this.all.push(entry);
      this.all.sort((a, b) => a.domain.localeCompare(b.domain));
      this.applyFilter();
      this.showAddPanel = false;
      this.snack.open(`${val} added`, 'OK', { duration: 2500 });
    } catch (e) {
      this.snack.open('Add failed. Please try again.', 'OK', { duration: 3000 });
    }
    this.adding = false;
  }
}
